import { countries } from 'data';
import { IDocuments } from '../../../types';

export type IDocumentState = IDocuments

export enum DocActionTypes {
  ADD_REQUIRED_DOCUMENT = '@@student/documents/ADD_REQUIRED_DOCUMENT',
  ADD_REQUIRED_DOCUMENT_SUCCESS = '@@student/documents/ADD_REQUIRED_DOCUMENT_SUCCESS',
  ADD_REQUIRED_DOCUMENT_FAILURE = '@@student/documents/ADD_REQUIRED_DOCUMENT_FAILURE',
  NO_BIOMETRICS = '@@student/documents/NO_BIOMETRICS',
  VISA_REFUSAL_DATE = '@@student/documents/VISA_REFUSAL_DATE',
  UPDATE_VISA_REFUSAL_META_DATA = '@@student/documents/UPDATE_VISA_REFUSAL_META_DATA',
  UPDATE_VISA_REFUSAL_META_DATA_SUCCESS = '@@student/documents/UPDATE_VISA_REFUSAL_META_DATA_SUCCESS',
  UPDATE_VISA_REFUSAL_META_DATA_FAILURE = '@@student/documents/UPDATE_VISA_REFUSAL_META_DATA_FAILURE',
  UPDATE_ATAS_PENDING = '@@student/documents/UPDATE_ATAS_PENDING',
  UPDATE_ATAS_SUCCESS = '@@student/documents/UPDATE_ATAS_SUCCESS',
  UPDATE_ATAS_FAILURE = '@@student/documents/UPDATE_ATAS_FAILURE',
  UPDATE_TB_TEST_META = '@@student/documents/UPDATE_TB_TEST_META',
  UPDATE_TB_SUCCESS = '@@student/documents/UPDATE_TB_SUCCESS',
  UPDATE_TB_FAILURE = '@@student/documents/UPDATE_TB_FAILURE',
  TOGGLE_ACKNOWLEDGE_DOC = '@@student/documents/TOGGLE_ACKNOWLEDGE_DOC',
  TOGGLE_ACKNOWLEDGE_DOC_SUCCESS = '@@student/documents/TOGGLE_ACKNOWLEDGE_DOC_SUCCESS',
  TOGGLE_ACKNOWLEDGE_DOC_FAILURE = '@@student/documents/TOGGLE_ACKNOWLEDGE_DOC_FAILURE'
}

export const isTBCountry = (countryName: string): boolean => {
  const country = countries.find(country => country.countryName === countryName);

  return country ? country.tb : false;
};

export const isATASCourseAndCountry = (countryName: string, isATASCourse: boolean): boolean => {
  const country = countries.find(country => country.countryName === countryName);
  return country ? isATASCourse && country.atas : false;
};
